import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import overlayimg from "./../../assets/images/resource/uipath.jpg";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/rpa-banner.png";
import { Link, useLocation } from "react-router-dom";

const AI_Accounting_Finance = () => {
  pageTitle("RPA in finance");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here

    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI_Accounting_Finance", slug: "/AI_Accounting_Finance" },
    { id: 2, title: "AI-Audit-Compliance", slug: "/AI-Audit-Compliance" },
    { id: 3, title: "AI-Human-Resources", slug: "/AI-Human-Resources" },
    { id: 4, title: "AI-Operations", slug: "/AI-Operations" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper">
        <img src={aiAccounting} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          <img
            src={overlayimg}
            alt="RPA Icon"
            className="ai-overlay-corner-img"
          />
          <h2>RPA For Accounting & Finance</h2>
        </div>
      </div>

      {/* RPA Accounting Impact Section */}
      <section className="rpa-af-section">
        <div className="container">
          {/* FULL WIDTH INTRO */}
          <div className="row">
            <div className="col-12">
              <div className="rpa-af-content">
                <h2 className="rpa-af-title">
                  RPA for Accounting and Finance Processes
                </h2>

                <p className="rpa-af-desc">
                  <span className="rpa-af-dropcap">T</span>
                  hough{" "}
                  <span className="rpa-af-highlight">
                    Robotic Process Automation
                  </span>{" "}
                  (RPA) is making a sweeping impact on businesses across the
                  board, there are certain industries and functions that are
                  more susceptible for a software automation implementation.
                  Accounting and finance, encompassing various manual and
                  repetitive processes, is one of the major automation-prone
                  business functions today.
                </p>
              </div>
            </div>
          </div>

          {/* TWO COLUMN SECTION */}
          <div className="row align-items-start mt-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              <h3 className="rpa-af-subtitle">What’s the Impact?</h3>

              <p className="rpa-af-desc">
                Between payroll processing, invoices, procurement, and
                reporting, various mundane tasks bog down accounting and finance
                departments on a daily basis. This significantly hinders human
                capital and innovative thinking within these departments and
                makes repetitive tasks more susceptible to human error.
              </p>
              <p className="rpa-af-desc mt-3">
                An RPA implementation can close the financial digitization gaps
                present within many organizations, reducing employee turnover
                and costs while increasing ROI. An implementation also enables
                the accounting and finance team to play a part in your RPA
                Center of Excellence (CoE), which is especially impactful for
                customer-facing department representatives.
              </p>
            </div>

            {/* RIGHT CARD */}
            <div className="col-lg-4">
              <div className="rpa-af-stats-card">
                <div className="rpa-af-stats-row">
                  <div className="rpa-af-stat">
                    <div className="rpa-af-icon">
                      <i className="fa-solid fa-clock"></i>
                    </div>
                    <div>
                      <h4>85%</h4>
                      <p>Time Saved</p>
                    </div>
                  </div>

                  <div className="rpa-af-stat">
                    <div className="rpa-af-icon">
                      <i className="fa-solid fa-sack-dollar"></i>
                    </div>
                    <div>
                      <h4>$30,000</h4>
                      <p>Cost Savings</p>
                    </div>
                  </div>
                </div>

                <p className="rpa-af-case-text">
                  Our education-sector client in Singapore automated the
                  following key accounting functions:
                </p>

                <ul className="rpa-af-case-list">
                  <li>Financial reconciliation processes</li>
                  <li>Invoice and payment processing</li>
                  <li>Daily and monthly reporting</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Use Cases Section */}
      <section className="rpa-uc-section">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT GRADIENT CARD */}
            <div className="col-lg-4">
              <div className="rpa-uc-card">
                <div className="rpa-uc-card-icon">
                  <i className="fa-solid fa-briefcase"></i>
                </div>

                <h3 className="rpa-uc-card-title">
                  Digitizing Accounting and
                  <br />
                  Finance Operations
                </h3>

                <ul className="rpa-uc-card-list">
                  <li>Improve productivity</li>
                  <li>Reduce operational costs</li>
                  <li>Maintain compliance</li>
                  <li>Ignite innovation by reducing stagnancy</li>
                </ul>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8">
              <div className="rpa-uc-content">
                <h2 className="rpa-uc-heading">
                  Key RPA Use Cases for Accounting and Finance Automation
                </h2>
                <div className="ai-solutions">
                  <div className="row">
                    <div className="col-12">
                      <ul className="rpa-uc-list">
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <li>
                              <Link
                                to="/payable"
                                target="_blank"
                                className="blinking"
                              >
                                <i className="icon-04"></i> Accounts Payable
                              </Link>
                            </li>
                          </div>

                          <div className="col-lg-6 col-md-12">
                            <li>
                              <Link
                                to="/Receivable"
                                target="_blank"
                                className="blinking"
                              >
                                <i className="icon-04"></i> Accounts Receivable
                              </Link>
                            </li>
                          </div>

                          <div className="col-lg-6 col-md-12">
                            <li>
                              <Link
                                to="/report"
                                target="_blank"
                                className="blinking"
                              >
                                <i className="icon-04"></i> Financial Reporting
                                & Reviews
                              </Link>
                            </li>
                          </div>

                          <div className="col-lg-6 col-md-12">
                            <li>
                              <Link
                                to="/reconciliation"
                                target="_blank"
                                className="blinking"
                              >
                                <i className="icon-04"></i> Reconciliation
                              </Link>
                            </li>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_Accounting_Finance;
